import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { actionTypes } from './actions'

const initialAuthState = {
  user: undefined,
  authToken: undefined,
  isLogin: false,
}

const storageConfig = {
  key: 'userInfo', // 儲存在LocalStorage的哪個Key值
  storage: storage, // 指定儲存在LocalStorage
  whitelist: ['user', 'authToken'], // reducer 裡面持久化的資料,除此外均為不持久化的資料
}

// const persistReducer = persistReducer(persistConfig, rootReducer);  // 包装rootReducer
export const reducer = persistReducer(storageConfig, (state = initialAuthState, action) => {
  switch (action.type) {
    case actionTypes.Login: {
      const { authToken } = action.payload
      const loginSuccess = authToken ? true : false
      return { authToken, user: undefined, isLogin: loginSuccess }
    }

    // 處理登入失敗
    case actionTypes.loginErrorDone: {
      return { ...state, isLogin: false }
    }

    // 處理capcha圖片loading成功
    case actionTypes.loadCaptchaImageSuccess: {
      const { data } = action.payload
      return { ...state, data }
    }

    case actionTypes.Register: {
      const { authToken } = action.payload
      console.log('actionTypes.Register:', authToken)
      // 是否有Token 有的話 isLogin = true
      const loginSuccess = authToken ? true : false
      return { authToken, user: undefined, isLogin: loginSuccess }
    }

    case actionTypes.Logout: {
      console.log('actionTypes.Logout:')
      localStorage.clear();
      return initialAuthState
    }

    // 把從action.payload的User 塞到Store裡面 並用persistor持久化
    case actionTypes.UserLoaded: {
      let { user } = action.payload
      console.log('actionTypes.UserLoaded:', user)
      const permissions = [true,false,true,false]
      user = {...user, permissions};
      console.log('reducer user = ', user)
      return { ...state, user }
    }

    case actionTypes.SetUser: {
      const { user } = action.payload
      console.log('actionTypes.SetUser:')
      return { ...state, user }
    }

    default:
      return state
  }
})
